import React from 'react';
import './MobileOptionsModal.css';

const MobileOptionsModal = ({ isOpen, onClose, onHelp, onUndo, onNewGame, canUndo }) => {
  if (!isOpen) return null;

  return (
    <div className="mobile-options-overlay" onClick={onClose}>
      <div className="mobile-options-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-options-header">
          <h3>Options</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="mobile-options-buttons">
          <button onClick={onHelp} className="mobile-option-btn help">
            ❓ Help
          </button>
          {canUndo && (
            <button onClick={onUndo} className="mobile-option-btn undo">
              ↩️ Undo
            </button>
          )}
          <button onClick={onNewGame} className="mobile-option-btn new-game">
            🎮 New Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileOptionsModal;